import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  // private sidebarCollapsedSignal = signal<boolean>(false);
  // isSidebarCollapsed = computed(() => this.sidebarCollapsedSignal());

  // toggleSidebar(): void {
  //   this.sidebarCollapsedSignal.update(state => !state);
  // }

  // setSidebarState(isCollapsed: boolean): void {
  //   this.sidebarCollapsedSignal.set(isCollapsed);
  // }
   open() {
    document.documentElement.classList.add('sidebar-enable');
    document.body.style.overflow = 'hidden';
  }

  close() {
    document.documentElement.classList.remove('sidebar-enable');
    document.body.style.overflow = '';
  }

  toggle() {
    document.documentElement.classList.contains('sidebar-enable')
      ? this.close()
      : this.open();
  }
}